import SlidingPanel from "@components/sliders/SlidingPanel";
import Switcher from "@components/switcher/Switcher";
import React, { useEffect, useState } from "react";
import Address from "./Address";
import IP from "./Ip";
import User from "./User";

interface WhitelistSliderProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (success: boolean) => void;
  userId: number;
  accountType: string;
}

const WhitelistSlider: React.FC<WhitelistSliderProps> = ({
  isOpen,
  onClose,
  onConfirm,
  userId,
  accountType,
}) => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchWhitelistSettings = async () => {};

  useEffect(() => {
    if (isOpen) fetchWhitelistSettings();
  }, [isOpen, userId]);

  if (error) {
    return (
      <SlidingPanel isOpen={isOpen} onClose={onClose}>
        <div className="p-4 text-red-500">{error}</div>
      </SlidingPanel>
    );
  }

  const tabs =
    accountType === "institutional" || accountType === "small_merchant"
      ? [
          {
            label: "ADDRESS",
            component: <Address userId={userId} />,
          },
          {
            label: "IP",
            component: <IP userId={userId} />,
          },
          {
            label: "USER",
            component: <User userId={userId} />,
          },
        ]
      : [
          {
            label: "ADDRESS",
            component: <Address userId={userId} />,
          },

          {
            label: "USER",
            component: <User userId={userId} />,
          },
        ];

  return (
    <div className="flex flex-col px-[16px] bg-bg-base">
      <div className="-mx-[16px]">
        <Switcher tabs={tabs} />
      </div>
    </div>
  );
};

export default WhitelistSlider;
